import { render, staticRenderFns } from "./steptwo.vue?vue&type=template&id=254d447f&scoped=true&"
import script from "./steptwo.vue?vue&type=script&lang=js&"
export * from "./steptwo.vue?vue&type=script&lang=js&"
import style0 from "./steptwo.vue?vue&type=style&index=0&id=254d447f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254d447f",
  null
  
)

export default component.exports